export default __webpack_public_path__ + "static/media/project.63d0af2d.svg";